<template>
    <div class="row">
        <div class="col-lg-12">


            <div v-if="errors.length > 0" class="alert alert-danger" role="alert">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <span v-for="error in errors">{{error}}<br/></span>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">

                        <label for="name">Name <span class="text-danger text-xs">*</span></label>

                        <input class="form-control" type="text" name="name" v-model="event.name" id="name" placeholder="" autofocus="" required="">
                    </div><!--form-group-->
                </div>
                <div class="col-lg-6">
                    <div class="form-group">

                        <label for="code">Template Code <span class=" text-xs"></span></label>

                        <input class="form-control" type="text" name="code" v-model="event.code" id="code" placeholder="Leave empty if no event specific template" autofocus="" required="">
                    </div><!--form-group-->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">

                        <label for="name">Start At <span class="text-danger text-xs">*</span></label>
                        <datetime v-model="event.start_at" type="datetime" input-class="form-control" format="y-LL-dd HH:mm" :minute-step="5" :week-start="7" :max-datetime="event.finish_at" value-zone="local" zone="local" ></datetime>
                    </div><!--form-group-->
                </div>
                <div class="col-lg-6">
                    <div class="form-group">

                        <label for="name">Registration Cut-off Date <span class="text-danger text-xs">*</span></label>
                        <datetime v-model="event.cutoff_at" type="date" input-class="form-control" format="y-LL-dd"  :week-start="7" :max-datetime="event.start_at" value-zone="local" zone="local" ></datetime>
                        <small class="form-text text-muted">
                            Guest will not be able to register after this date
                        </small>
                    </div><!--form-group-->
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Event Banner</label><br/>
                        <croppa v-model="banner.src" :width="600"
                            :height="banner_height"
                            :initial-image="banner.initial"
                            placeholder="Upload"
                            placeholder-color="#858796"
                            :placeholder-font-size="16"
                            canvas-color="transparent"
                            :show-remove-button="true"
                            remove-button-color="black"
                            :remove-button-size="16"
                            :show-loading="true"
                            :loading-size="50"
                            :prevent-white-space="true"
                            loading-color="#606060"></croppa>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">

                    <div class="form-group">

                        <label for="invitation_subject">Invitation Subject <span class="text-danger text-xs">*</span></label>

                        <input class="form-control" type="text" id="invitation_subject" name="invitation_subject" v-model="event.invitation_subject" placeholder="e.g. Invitation to Event Name" autofocus="" required="">
                    </div><!--form-group-->
                </div>
                <div class="col-lg-6">

                    <div class="form-group">

                        <label for="confirmation_subject">Confirmation Subject <span class="text-danger text-xs">*</span></label>

                        <input class="form-control" type="text" id="confirmation_subject" name="confirmation_subject" v-model="event.confirmation_subject" placeholder="e.g. Confirmation of Event Name" autofocus="" required="">
                    </div><!--form-group-->
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-lg-6">
                    <div class="form-group">
                        <label for="venue_address">Venue <span class="text-danger text-xs">*</span></label>

                        <textarea class="form-control" name="venue_address" v-model="event.venue_address" id="venue_address" placeholder="" spellcheck="false" rows="5"></textarea>
                    </div>
                </div>-->
                <div class="col-lg-6">

                    <div class="form-group">
                        <label for="invitation_message">Invitation Message <span class="text-danger text-xs">*</span></label>

                        <textarea class="form-control" name="invitation_message" v-model="event.invitation_message" id="invitation_message" placeholder="e.g. You are cordially invited to attend this event." spellcheck="false" rows="8"></textarea>
                    </div><!--form-group-->
                </div>
                <div class="col-lg-6">

                    <div class="form-group">
                        <label for="contact">Closing Message & Signature <span class="text-danger text-xs">*</span></label>

                        <textarea class="form-control" name="contact" v-model="event.contact" id="contact" placeholder="e.g. Should you have any enquiry about this event, please contact:
Mr. Contact Person
Email: someone@event.com
Tel: (852) 8888 8888

Best Regards,
The Company" spellcheck="false" rows="8"></textarea>
                    </div><!--form-group-->
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group mb-0">
                        <label for="">Additional Informations</label>
                    </div>
                </div>
            </div>
            <div class="row" v-for="(info, index) in event.additional_infos">
                <div class="col-lg-2">
                    <div class="form-group">
                        <select v-model="info.display" class="form-control">
                            <option value="all">Display in All Email</option>
                            <option value="invitation">Invitation Email</option>
                            <option value="confirmation">Confirmation Email</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <input class="form-control" type="text" v-model="info.title" placeholder="e.g. Venue" autofocus="" required="">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <div class="input-group">
                            <textarea class="form-control" name="" v-model="info.content" placeholder="e.g. Hong Kong Convention and Exhibition Centre" spellcheck="false" rows="3"></textarea>
                            <div class="input-group-append">
                                <button class="btn btn-outline-danger" type="button" @click="removeInfo(index)">
                                    <i class="fas fa-trash-alt fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <button type="button" class="btn btn-outline-success btn-block" @click="addInfo()"><i class="fas fa-plus"></i> Add New Additional Information</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">

                    <div class="form-group">
                        <label >Options</label>

                        <div class="custom-control custom-switch">
                            <input type="checkbox" value="1" v-model="event.opt_forward" class="custom-control-input" id="switch_forward">
                            <label class="custom-control-label" for="switch_forward">Forward invitation to other</label>
                        </div>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" value="1" v-model="event.opt_register_for_other" class="custom-control-input" id="switch_register_for_other">
                            <label class="custom-control-label" for="switch_register_for_other">Register for other</label>
                        </div>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" value="1" v-model="event.opt_qrcode" class="custom-control-input" id="switch_qrcode">
                            <label class="custom-control-label" for="switch_qrcode">Enable QR Code check-in</label>
                        </div>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" value="1" v-model="event.opt_hide_event_title" class="custom-control-input" id="switch_hide_event_title">
                            <label class="custom-control-label" for="switch_hide_event_title">Hide Event Title in email (if you have event name displayed in banner already)</label>
                        </div>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" value="1" v-model="event.opt_greet_by_guest_name" class="custom-control-input" id="switch_greet_by_guest_name">
                            <label class="custom-control-label" for="switch_greet_by_guest_name">Use Dear [Guest Name]</label>
                        </div>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" value="1" v-model="event.opt_options_in_email" class="custom-control-input" id="switch_options_in_email">
                            <label class="custom-control-label" for="switch_options_in_email">Display ACCEPT/REJECT options in email directly</label>
                        </div>
                    </div><!--form-group-->
                </div>
            </div>
            <!--<div class="row">
                <div class="col-lg-6">

                    <div class="form-group">

                        <label for="subject">Email Subject</label>

                        <input class="form-control" type="text" id="subject" name="subject" v-model="event.subject" placeholder="" autofocus="" required="">
                    </div>&lt;!&ndash;form-group&ndash;&gt;
                </div>
            </div>-->
            <div class="row">
                <div class="col-lg-6">

                    <div class="form-group">

                        <label for="sender_name">Sender Name <span class="text-danger text-xs">*</span></label>

                        <input class="form-control" type="text" id="sender_name" name="sender_name" v-model="event.sender_name" placeholder="" autofocus="" required="">
                    </div><!--form-group-->
                </div>
                <div class="col-lg-6">

                    <div class="form-group">

                        <label for="sender_email">Sender Email <span class="text-danger text-xs">*</span></label>

                        <input class="form-control" type="text" id="sender_email" name="sender_email" v-model="event.sender_email" placeholder="" autofocus="" required="">
                    </div><!--form-group-->
                </div>
            </div>


            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">

                        <label>Contact List <span class="text-danger text-xs">*</span></label>
                        <v-select label="name" :options="contact_lists" v-model="event.contact_list" placeholder="Please select a contact list">
                            <template v-slot:selected-option="option">
                                {{ option.name }}&nbsp;<span class="badge badge-primary">{{ option.contacts_count }} contacts</span>
                            </template>
                            <template v-slot:option="option">
                                {{ option.name }}&nbsp;<span class="badge badge-primary">{{ option.contacts_count }} contacts</span>
                            </template>
                        </v-select>

                    </div><!--form-group-->
                </div><!--col-->
            </div><!--row-->
            <div class="row">
                <div class="col mb-3">
                    <vue-bootstrap4-table :rows="event.recipients" :columns="dt.columns" :config="dt.config" :classes="dt.classes">
                        <template slot="sort-asc-icon">
                            <i class="fas fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                            <i class="fas fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                            <i class="fas fa-sort text-gray-200"></i>
                        </template>
                        <!--<template slot="action" slot-scope="props">
                            <button class="btn btn-primary btn-icon-split" @click="tests(props.row.Tel)">
                                <span class="icon text-white-50">
                                  <i class="fas fa-arrow-left "></i>
                                </span>
                                <span class="text">Log</span>
                            </button>
                        </template>-->
                    </vue-bootstrap4-table>

                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="form-group mb-0 clearfix">

                        <button class="btn btn-success btn-icon-split" @click="saveDraft">
                            <span class="icon text-white-50">
                              <i class="fas fa-save "></i>
                            </span>
                            <span class="text">Save For Later</span>
                        </button>
                        <button class="btn btn-success btn-icon-split" @click="saveSend">
                            <span class="icon text-white-50">
                              <i class="fas fa-paper-plane"></i>
                            </span>
                            <span class="text">Save & Send</span>
                        </button>
                    </div><!--form-group-->
                </div><!--col-->
            </div><!--row-->
        </div>
    </div>

        <!--<div class="col-lg-8">
            <ul class="nav nav-tabs" id="preview-tab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="desktop_preview-tab" data-toggle="tab" href="#desktop_preview" role="tab" aria-controls="desktop_preview" aria-selected="true">Desktop</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="mobile_preview-tab" data-toggle="tab" href="#mobile_preview" role="tab" aria-controls="mobile_preview" aria-selected="false">Mobile</a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane fade show active border bg-gradient-dark" id="desktop_preview" role="tabpanel" aria-labelledby="desktop_preview-tab">
                    <div>
                        <invitation-preview :event="event"></invitation-preview>
                    </div>
                </div>
                <div class="tab-pane fade border bg-gradient-dark" id="mobile_preview" role="tabpanel" aria-labelledby="mobile_preview-tab" >
                    <div style="max-width:360px;margin:0 auto;">
                        <invitation-preview :event="event"></invitation-preview>
                    </div>
                </div>
            </div>

        </div>-->

</template>

<script>
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    //import Stepper from 'bs-stepper'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import Croppa from 'vue-croppa'
    import 'vue-croppa/dist/vue-croppa.css'
    import vSelect from 'vue-select'
    import 'vue-select/src/scss/vue-select.scss'

    var moment = require('moment')
    moment().format()

    export default {
        name: 'EventForm',
        data() {
            return {
                regex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(\s?,\s?(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))?$/,
                event: {
                    hashid: null,
                    name: null,
                    code: null,
                    venue_name: null,
                    venue_address: null,
                    invitation_message: null,
                    capacity: null,
                    banner: null,
                    additional_infos: [],
                    opt_forward: false,
                    opt_register_for_other: false,
                    opt_qrcode: false,
                    opt_greet_by_guest_name: false,
                    opt_options_in_email: false,
                    opt_hide_event_title: false,
                    contact: null,
                    invitation_subject: null,
                    confirmation_subject: null,
                    sender_name: null,
                    sender_email: null,
                    recipients: [],
                    contact_list: null,
                    start_at: null,
                    finish_at: null,
                    cutoff_at: null,
                },
                contact_lists: [],
                banner: {
                    initial: null,
                    src: null,
                    blob: null
                },
                draft: true,
                test: {
                    email:null,
                    name: null,
                },
                errors: [],
                //stepper: null,
                dt: {
                    classes: {
                        table: {
                            "table-striped": true,
                        }
                    },
                    columns: [
                        {
                            label: "Name",
                            name: "name",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Email",
                            name: "email",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            //slot_name: "action"
                        },
                        {
                            label: "Company Name",
                            name: "company",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Job Title",
                            name: "job_title",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Tel",
                            name: "tel",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                    ],
                    config: {
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        per_page: 50,
                        per_page_options:  [50,  100,  200,  500],
                    }
                },
            }
        },
        components: {
            datetime: Datetime,
            VueBootstrap4Table,
            croppa: Croppa.component,
            'v-select': vSelect
        },
        props: {
            hashid: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
        },
        computed: {
            'banner_height': function () {
                if (this.banner.src && this.banner.src.naturalHeight > 0)
                    return this.banner.src.naturalHeight/(this.banner.src.naturalWidth/600);
                else
                    return 200
            }
        },
        watch: {
            'event.contact_list': function (val) {
                axios.get('/api/contactlist/'+val.hashid).then((response) => {
                    this.event.recipients = response.data.contactlist.contacts
                }).catch((error) => {
                    /*Swal.fire({
                        title: 'Error',
                        text: 'Unable to retrieve record',
                        icon: 'error',
                        confirmButtonText: 'Dismiss'
                    }).then((result) => {
                        location.href='/event'
                    });*/
                })
            },
        },
        methods: {
            addInfo() {
                this.event.additional_infos.push({display:'all',title:null,content:null})
            },
            removeInfo(index) {
                this.event.additional_infos.splice(index, 1);
            },
            validate() {
                this.errors = []
                if (this.event.name == null || this.event.name.length == 0)
                {
                    this.errors.push('Event Name is required')
                }
                if (this.event.invitation_message == null || this.event.invitation_message.length == 0)
                {
                    this.errors.push('Invitation Message is required')
                }
                if (this.event.contact == null || this.event.contact.length == 0)
                {
                    this.errors.push('Closing Message & Signature is required')
                }
                /*if (this.event.venue_name == null || this.event.venue_name.length == 0)
                {
                    this.errors.push('Venue Name is required')
                }
                if (this.event.venue_address == null || this.event.venue_address.length == 0)
                {
                    this.errors.push('Venue Address is required')
                }*/
                if (this.event.start_at == null || this.event.start_at.length == 0)
                {
                    this.errors.push('Start Time is required')
                }
                /*if (this.event.finish_at == null || this.event.finish_at.length == 0)
                {
                    this.errors.push('Finish Time is required')
                }*/
                if (this.event.cutoff_at == null || this.event.cutoff_at.length == 0)
                {
                    this.errors.push('Registration Cut-off Date is required')
                }
                if (this.event.invitation_subject == null || this.event.invitation_subject.length == 0)
                {
                    this.errors.push('Invitation Subject is required')
                }
                if (this.event.confirmation_subject == null || this.event.confirmation_subject.length == 0)
                {
                    this.errors.push('Confirmation Subject is required')
                }
                if (this.event.sender_name == null || this.event.sender_name.length == 0)
                {
                    this.errors.push('Sender Name is required')
                }
                if (this.event.sender_email == null || this.event.sender_email.length == 0 || !this.regex.test(String(this.event.sender_email).toLowerCase()))
                {
                    this.errors.push('Sender Email is required and must be a valid email')
                }

            },
            saveDraft() {
                this.draft = true
                this.save()
            },
            saveSend() {
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'This event invitation will be sent immediately',
                    icon: 'question',
                    confirmButtonText: 'Send Now',
                    cancelButtonText: 'No, Not Now',
                    showCancelButton: true,
                    focusCancel: true,
                }).then((result) => {
                    if (result.value) {
                        this.draft = false
                        this.save()
                    }
                })

            },
            async save() {

                let formData = new FormData()
                if (this.event.hashid)
                    formData.append('event[hashid]', this.event.hashid)
                if (this.event.name)
                    formData.append('event[name]', this.event.name)
                if (this.event.code)
                    formData.append('event[code]', this.event.code)
                if (this.event.start_at)
                    formData.append('event[start_at]', this.event.start_at)
                if (this.event.cutoff_at)
                    formData.append('event[cutoff_at]', this.event.cutoff_at)
                if (this.event.venue_address)
                    formData.append('event[venue_address]', this.event.venue_address)
                if (this.event.invitation_message)
                    formData.append('event[invitation_message]', this.event.invitation_message)
                if (this.event.additional_infos.length > 0)
                {
                    for ( var i=0; i < this.event.additional_infos.length; i++)
                    {

                        formData.append('event[additional_infos]['+i+'][display]', this.event.additional_infos[i].display)
                        formData.append('event[additional_infos]['+i+'][title]', this.event.additional_infos[i].title)
                        formData.append('event[additional_infos]['+i+'][content]', this.event.additional_infos[i].content)

                    }
                }
                if (this.event.contact)
                    formData.append('event[contact]', this.event.contact)
                formData.append('event[opt_register_for_other]', this.event.opt_register_for_other?1:0)
                formData.append('event[opt_forward]', this.event.opt_forward?1:0)
                formData.append('event[opt_qrcode]', this.event.opt_qrcode?1:0)
                formData.append('event[opt_greet_by_guest_name]', this.event.opt_greet_by_guest_name?1:0)
                formData.append('event[opt_options_in_email]', this.event.opt_options_in_email?1:0)
                formData.append('event[opt_hide_event_title]', this.event.opt_hide_event_title?1:0)
                if (this.event.invitation_subject)
                    formData.append('event[invitation_subject]', this.event.invitation_subject)
                if (this.event.confirmation_subject)
                    formData.append('event[confirmation_subject]', this.event.confirmation_subject)
                if (this.event.sender_name)
                    formData.append('event[sender_name]', this.event.sender_name)
                if (this.event.sender_email)
                    formData.append('event[sender_email]', this.event.sender_email)
                if (this.event.contact_list)
                    formData.append('event[contact_list][hashid]', this.event.contact_list.hashid)
                formData.append('draft', this.draft?1:0)

                if (this.banner.src.hasImage()) {
                    /*this.banner.src.generateBlob((blob) => {
                        this.banner.blob = blob
                    })*/
                    this.banner.blob = await this.banner.src.promisedBlob()
                    formData.append('banner', this.banner.blob, 'banner.jpg')
                }

                if (this.hashid.length > 0)
                {
                    formData.append('_method', 'PATCH')
                    axios.post('/event/'+this.event.hashid, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                        Swal.fire({
                            title: 'Success',
                            text: 'Record saved successfully',
                            icon: 'success',
                            confirmButtonText: 'Done'
                        }).then((result) => {
                            location.href='/event'
                        })
                    }).catch((error) => {
                        // TODO: handle validation error
                        Swal.fire({
                            title: 'Error',
                            text: 'There are problems in the form',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            this.errors = error.response.data.errors
                            window.scrollToTop()
                        })
                    })
                }
                else
                {
                    axios.post('/event', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                        Swal.fire({
                            title: 'Success',
                            text: 'Record saved successfully',
                            icon: 'success',
                            confirmButtonText: 'Done'
                        }).then((result) => {
                            location.href='/event'
                        })
                    }).catch((error) => {
                        // TODO:  handle validation error
                        Swal.fire({
                            title: 'Error',
                            text: 'There are problems in the form',
                            icon: 'error',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            this.errors = error.response.data.errors
                            window.scrollToTop()
                        })
                    })
                }

            }
        },
        mounted() {
            if (this.hashid.length > 0)
            {
                axios.get('/api/event/'+this.hashid).then((response) => {
                    this.event = _.merge(this.event,response.data.event)
                    if (this.event.start_at)
                        this.event.start_at = moment(this.event.start_at, 'YYYY-MM-DD HH:mm:ss').format()
                    /*if (this.event.finish_at)
                        this.event.finish_at = moment(this.event.finish_at, 'YYYY-MM-DD HH:mm:ss').format()*/
                    if (this.event.cutoff_at)
                        this.event.cutoff_at = moment(this.event.cutoff_at, 'YYYY-MM-DD HH:mm:ss').format()
                    /*if (this.event.recipients_json)
                    {
                        this.event.recipients = JSON.parse(this.event.recipients_json)
                    }
                    else
                    {
                        this.event.recipients = []
                    }*/
                    if (this.event.banner)
                    {
                        var image = new Image()
                        // Notice: it's necessary to set "crossorigin" attribute before "src" attribute.
                        image.setAttribute('crossorigin', 'anonymous')
                        image.src = this.event.banner

                        this.banner.initial = image
                        this.banner.src.refresh()
                    }
                }).catch((error) => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Unable to retrieve record',
                        icon: 'error',
                        confirmButtonText: 'Dismiss'
                    }).then((result) => {
                        location.href='/event'
                    });
                });
                //this.stepper = new Stepper($('.bs-stepper')[0])
            }
            axios.get('/api/contactlist').then((response) => {
                this.contact_lists = response.data.contactlists
            }).catch((error) => {
                Swal.fire({
                    title: 'Error',
                    text: 'Unable to retrieve record',
                    icon: 'error',
                    confirmButtonText: 'Dismiss'
                }).then((result) => {
                    location.href='/event'
                });
            })

        }
    }
</script>
<style>
    /*@import 'https://cdn.jsdelivr.net/npm/bs-stepper/dist/css/bs-stepper.min.css'*/
    .croppa-container {
        background-color: white;
        border: 1px solid #d1d3e2;
        border-radius: 0.35rem;
    }

    .croppa-container:hover {
        opacity: 0.5;
        background-color: #d1d3e2;
    }

    .v-select {
        height: calc(1.5em + 0.75rem + 2px);
    }

    .v-select .vs__search::placeholder,
    .v-select .vs__selected
    {
        line-height:1.5;
        font-size:1rem;
        font-weight:400;
        color:#6e707e;
        font-family: Nunito;
    }


</style>
